/**
 * @generated SignedSource<<2873f2884d4368ba4dad2f8ad246893a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CloudProvider = "AWS" | "Anthropic" | "Azure" | "GCP" | "Kubernetes" | "TencentCloud" | "%future added value";
export type StatusValue = "ERROR" | "PARTIAL_SUCCESS" | "SKIPPED" | "SUCCESS" | "UNAVAILABLE" | "%future added value";
export type AccountInput = {
  description?: string | null | undefined;
  email?: string | null | undefined;
  key: string;
  name: string;
  orgId?: string | null | undefined;
  path?: string | null | undefined;
  provider: CloudProvider;
  securityContext?: string | null | undefined;
  shortName?: string | null | undefined;
  tags?: ReadonlyArray<TagInput> | null | undefined;
  variables?: string | null | undefined;
};
export type TagInput = {
  key: string;
  value?: string | null | undefined;
};
export type AddAccountMutation$variables = {
  connections: ReadonlyArray<string>;
  input: AccountInput;
};
export type AddAccountMutation$data = {
  readonly addAccount: {
    readonly account: {
      readonly email: string | null | undefined;
      readonly id: string;
      readonly key: string;
      readonly name: string;
      readonly path: string | null | undefined;
      readonly provider: CloudProvider;
      readonly securityContext: string;
      readonly statusInfo: {
        readonly details: ReadonlyArray<{
          readonly at: string | null | undefined;
          readonly component: string;
          readonly message: string | null | undefined;
          readonly status: StatusValue | null | undefined;
        }>;
      };
    } | null | undefined;
  } | null | undefined;
};
export type AddAccountMutation = {
  response: AddAccountMutation$data;
  variables: AddAccountMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "Account",
  "kind": "LinkedField",
  "name": "account",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "path",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "provider",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "securityContext",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StatusInfo",
      "kind": "LinkedField",
      "name": "statusInfo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "StatusDetail",
          "kind": "LinkedField",
          "name": "details",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "at",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "component",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "message",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AddAccountMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "AccountPayload",
        "kind": "LinkedField",
        "name": "addAccount",
        "plural": false,
        "selections": [
          (v2/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "AddAccountMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "AccountPayload",
        "kind": "LinkedField",
        "name": "addAccount",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "appendNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "account",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "AccountEdge"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8a453042c4fac2fb6c0fbe3c2cb55c84",
    "id": null,
    "metadata": {},
    "name": "AddAccountMutation",
    "operationKind": "mutation",
    "text": "mutation AddAccountMutation(\n  $input: AccountInput!\n) {\n  addAccount(input: $input) {\n    account {\n      email\n      id\n      key\n      name\n      path\n      provider\n      securityContext\n      statusInfo {\n        details {\n          at\n          component\n          message\n          status\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "18add28074ed97e87db63b6801fb7951";

export default node;
